export default __webpack_public_path__ + "static/SRC 7S7001 - Product Specifications & Technical Data-df6a97f01ea4c8b3d75b705c40610a1e.pdf";